import Big from 'big.js';

import { PI_BY_180 } from '../constants/math';

export function degreesToRadians(degrees) {
  return degrees * PI_BY_180;
}

export function radiansToDegrees(radians) {
  return radians / PI_BY_180;
}

export function decrease(number) {
  return number - 1;
}

export function increase(number) {
  return number + 1;
}

export function discretise(value, decimals = 0) {
  const denomerator = decimals
    ? new Big(10).pow(decimals)
    : 1;

  function getFraction(number) {
    return new Big(number).div(denomerator);
  }

  const round = new Big(value).round(decimals, 0);
  const mod = round.mod(getFraction(10));

  return mod.gt(getFraction(4))
    ? round.plus(getFraction(5)).minus(mod).toNumber()
    : round.minus(mod).toNumber();
}

export function getAngleBetweenVectors(x1, y1, x2, y2, x3, y3, x4, y4) {
  const v1 = [(x2 - x1), (y2 - y1)];
  const v2 = [(x4 - x3), (y4 - y3)];

  return Math.acos(
    (v1[0] * v2[0] + v1[1] * v2[1]) /
    (Math.sqrt(Math.pow(v1[0], 2) + Math.pow(v1[1], 2)) * Math.sqrt(Math.pow(v2[0], 2) + Math.pow(v2[1], 2)))
  );
}

